module.exports = __webpack_public_path__ + "img/5.d9c0c5eb.jpg";